export interface PromoBannerProps {
  title: string;
  subtitle: string;
  link: string;
  linkText: string;
  bgImage: string;
  align?: string;
}

/**
 * Génère le HTML statique d'un bandeau promotionnel.
 * Utilisé dans cleanContent pour remplacer les div data-component="pbanner".
 */
export function renderPromoBannerHTML({ title, subtitle, link, linkText, bgImage }: PromoBannerProps): string {
  return `<a href="${link}" target="_blank" rel="noopener noreferrer"
    class="not-prose !block my-8 rounded-2xl overflow-hidden relative min-h-[200px] !no-underline">
    <img src="${bgImage}" alt="" class="absolute inset-0 w-full !h-full object-cover !m-0 !rounded-none !shadow-none" />
    <div class="absolute inset-0 bg-gray-900/70"></div>
    <div class="relative px-6 py-8 sm:px-10 sm:py-10 text-center">
      <p class="text-xl sm:text-2xl !font-bold !text-white mt-0 mb-2 leading-tight">${title}</p>
      <p class="text-sm sm:text-base !text-white/85 mt-0 mb-6 max-w-xl mx-auto leading-relaxed">${subtitle}</p>
      <span class="inline-flex items-center gap-2 px-6 py-3 bg-red-500 !text-white font-semibold rounded-full text-sm sm:text-base">
        ${linkText}
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
      </span>
    </div>
  </a>`;
}
